import Vue from 'vue'
import vue2Dropzone from "vue2-dropzone";

Vue.component("vue-dropzone", vue2Dropzone)
